import { useState } from 'react';
import { FAIcon, IconStyle, Theme, useTranslation } from '@nextgen-web-framework/all';
import { AddToListDrawer } from '@commerce-cart-webcomponents/ui';
import { type AppState } from '@nextgen-web-framework/core';
import { InitialCartListState } from '@commerce-cart-webcomponents/sdk';
import { useSelector } from 'react-redux';
import { MyListsPage } from '../my-lists-page/MyListsPage';
import styles from './ListContainer.module.scss';
import { ListContainerProps } from './types/propsType';

export const ListContainer = ({ isReceiver = false, onListCountChange, profileId, accountId }: ListContainerProps) => {
  const t = useTranslation();
  const [displayAddToListDrawer, setDisplayAddToListDrawer] = useState(false);
  const containerHeaderText = t('cart.myShopListContainer.header');
  const containerDescriptionText = t('cart.myShopListContainer.description');
  const containerLinkText = t('cart.myShopListContainer.linkText');
  const [listUpdated, setListUpdated] = useState<boolean>(false);
  //const [categorySelected, setCategorySelected] = useState('');
  const { listsByUser } = useSelector((state: AppState) => state.commerceMyList) as InitialCartListState;
  const listExistsInMyShop = Boolean(listsByUser?.lists?.length);
  //const categoryAll = t('cart.myListsPage.all');
  const addToListDrawerCb = () => {
    setListUpdated(!listUpdated);
  };

  // const categoryFilterHandler = (category: string) => {
  //   setCategorySelected(category);
  // };

  return (
    <>
      {!(isReceiver && listsByUser?.maxCount === 0) && (
        <>
          <div className={`${styles['myshop-list-container']} ${listExistsInMyShop && styles['listExist']}`}>
            <div className={styles['myshop-list-container-header']}>
              {containerHeaderText}
              {!listExistsInMyShop && !isReceiver && (
                <div className={styles['myshop-list-container-description']}>{containerDescriptionText}</div>
              )}
            </div>
            {!isReceiver && (
              <div
                aria-label="text-link-button"
                data-testid="test-textlink-button"
                onKeyDown={() => setDisplayAddToListDrawer(true)}
                onClick={() => setDisplayAddToListDrawer(true)}
                role="button"
                tabIndex={0}
                className={styles['myshop-list-container-link-container']}
              >
                <span className={styles['myshop-list-container-plus-icon']}>
                  <FAIcon iconStyle={IconStyle.SOLID} theme={Theme.BLUE} iconName="plus" />
                  <span className={styles['myshop-list-container-icon-text']}></span>
                </span>
                <span className={styles['myshop-list-container-link-container-text']}>{containerLinkText}</span>
              </div>
            )}
          </div>
          {displayAddToListDrawer && (
            <AddToListDrawer
              isMyShop={true}
              onDrawerClose={() => setDisplayAddToListDrawer(false)}
              fetchMyShopListsCB={addToListDrawerCb}
              showCreateListForm={listsByUser?.maxCount === 1}
            />
          )}
          <MyListsPage
            onListUpdate={listUpdated} // on add list to myshop drawer confirm btn update
            isReceiver={isReceiver}
            isMyShop={true}
            updateListLength={(num) => onListCountChange?.(num)}
            profileId={profileId}
            accountId={accountId}
            // onCategoryFilterChange={(category) => categoryFilterHandler(category)}
          />
        </>
      )}
    </>
  );
};
